import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";

import { FavoriteProfile } from "../../common/FavoriteProfile";
import { SocialFacebook } from "../../common/SocialFacebook";
import { PhoneIcon } from "../../../assets/image/PhoneIcon";
import { ServiceIcon } from "../../../assets/image/ServiceIcon";
import { StarIcon } from "../../../assets/image/StarIcon";
import { WhiteStarIcon } from "../../../assets/image/WhiteStarIcon";
import { SearchIcon } from "../../../assets/image/SearchIcon";
import { MarkRoundIcon } from "../../../assets/image/MarkRoundIcon";
import { useTranslation } from "react-i18next";
import { ConfirmIcon } from "../../../assets/image/ConfirmIcon";

export const JobCard = ({
                          data,
                          jobData,
                          hired,
                          handleAcceptData,
                          setView,
                          handleElementById,
                          profile,
                          index,
                          providerData,
                        }) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const renderServiceIcon = (serviceType) => {
    switch (serviceType) {
      case "tab1":
        return (
            <img src={`${window.location.origin}/images/nany_post.svg`} alt="" />
        );
      case "tab2":
        return (
            <img
                src={`${window.location.origin}/images/teacher_post.svg`}
                alt=""
            />
        );
      case "tab3":
        return (
            <img
                src={`${window.location.origin}/images/education_post.svg`}
                alt=""
            />
        );
      case "tab4":
        return (
            <img src={`${window.location.origin}/images/tutor_post.svg`} alt="" />
        );
      default:
        return null;
    }
  };

  const getPrice = (serviceType) => {
    switch (serviceType) {
      case "tab1":
        return data.nanyperhrrate;
      case "tab2":
        return data.seterhrrate;
      case "tab3":
        return data.seperhrrate;
      case "tab4":
        return data.tutorperhrrate;
      default:
        return null;
    }
  };

  const parseIfJson = (value) => {
    try {
      return typeof value === "string" ? JSON.parse(value) : value;
    } catch {
      return value;
    }
  };

  const getTranslatedInterest = () => {
    const interestedIn = data.tutorintrestedin || data.nanyintrestedin;
    const interest = parseIfJson(interestedIn);

    if (typeof interest === "string") return t(interest);
    if (interest?.occasionally && interest.occasionally !== "") return t(interest.occasionally);
    if (interest?.fulltime && interest.fulltime !== "") return t(interest.fulltime);
    if (interest?.parttime && interest.parttime !== "") return t(interest.parttime);
    return t(interest.occasionally);
  };

  return (
      <div className="looking_for_candidate_boxs">
        <div className="looking_for_candidate_box">
          <div className="candidate_info">
            <div className="profile_info">
            <div className="first_sec">
            <div className="image_sec">
              <img
                  src={
                    data.file_path != null
                        ? `https://admin.stage.mysenscare.com/assets/images/users/${data.file_path}`
                        : "img/nany_img.png"
                  }
                  alt=""
                  onClick={() => navigate(`/profile-provider/${data.user_id}`)}
              />
              <div className="heart_sec">
                <FavoriteProfile id={data.user_id} username={data.first_name} />
              </div>
            </div>
            <div className="nany_social">
              {data.phoneVerifiedStatus == 1 ? (
                  <img
                      src={`${window.location.origin}/images/nany_phone.svg`}
                      alt=""
                  />
              ) : (
                  <PhoneIcon />
              )}
              <img src={`${window.location.origin}/images/nany_msg.svg`} alt="" />
              {data.facebookverify != null || data.linkdinverify != null ? (
                  <img
                      src={`${window.location.origin}/images/nany_cont.svg`}
                      alt=""
                  />
              ) : (
                  <ServiceIcon />
              )}
              {data.backgroundstatus == "Confirmed" ? (
                  <img src={`${window.location.origin}/images/ok.svg`} alt="" />
              ) : (
                  <ConfirmIcon />
              )}
            </div>
          </div>

          <div className="second_sec">
            <div className="heading">
              <h3 onClick={() => navigate(`/profile-provider/${data.user_id}`)}>
                {jobData.jobstatus?.JobStatus != 1 ? (
                    ""
                ) : (
                    <span className="new-tag3"> {t("text-closed")}</span>
                )}
                {data.profile_headline != null ? data.profile_headline : ""}
              </h3>
              {jobData.jobstatus?.JobStatus != 1 ? (
                  <button
                      style={
                        hired != "" || data.applyjob_hiredstatus == 1
                            ? { opacity: "0.5", width: "75px", fontSize: "11px" }
                            : {}
                      }
                      onClick={(e) => handleAcceptData(data.Appjob_ID)}
                      disabled={
                        hired != "" || data.applyjob_hiredstatus == 1 ? true : false
                      }
                  >
                    {hired != "" || data.applyjob_hiredstatus == 1
                        ? t("text-hired")
                        : t("text-hire")}
                  </button>
              ) : (
                  ""
              )}

            </div>
            <div className="post_general">
              <h6>
                <Link to={`/profile-provider/${providerData[0]?.user_id}`}>
                  {data.first_name != null
                      ? `${data.first_name} ${data.last_name}`
                      : ""}
                </Link>
                (
                {data.dob != undefined
                    ? new Date().getFullYear() - parseInt(data.dob.split("-")[0])
                    : ""}
                )
              </h6>
              <p>
                {jobData.reviewAvg >= 0 ? (
                    <>
                      {[...Array(jobData.reviewAvg)].map((star, index) => (
                          <StarIcon key={index} />
                      ))}
                      {[...Array(5 - jobData.reviewAvg)].map((star, index) => (
                          <WhiteStarIcon key={index} />
                      ))}
                    </>
                ) : (
                    ""
                )}
                <span> ({jobData.reviewcount})</span>
              </p>
            </div>
            <div className="post_detail">
              <div className="post">
                {data.service_type != null
                    ? renderServiceIcon(
                        Object.keys(JSON.parse(data.service_type))[0]
                    )
                    : ""}
                <h5>
                  {data.service_type != null
                      ? t(Object.values(JSON.parse(data.service_type))[0])
                      : ""}
                </h5>
              </div>
              <div className="vi-special"></div>
              <div className="post_pay">
                <img
                    src={window.location.origin + "/img/post_pay.png"}
                    alt=""
                />
                {language == 'sr' ? (
                    <h5>
                      {getPrice(Object.keys(JSON.parse(data.service_type))[0]) !== null
                          ? getPrice(Object.keys(JSON.parse(data.service_type))[0])
                              .substr(getPrice(Object.keys(JSON.parse(data.service_type))[0]).lastIndexOf("\\") + 1)
                              .split("-")[0] *
                          100 +
                          " - " +
                          getPrice(Object.keys(JSON.parse(data.service_type))[0])
                              .substr(getPrice(Object.keys(JSON.parse(data.service_type))[0]).lastIndexOf("\\") + 1)
                              .split("-")[1] *
                          100

                                      : ""}
                      {t("time-hour")}
                    </h5>
                ) : (
                    <h5>
                      $
                      {getPrice(Object.keys(JSON.parse(data.service_type))[0]) != null ?
                        getPrice(Object.keys(JSON.parse(data.service_type))[0])
                        : ""}
                      {t("time-hour")}
                    </h5>
                )}
              </div>
              <div className="vi"></div>
              {data.service_type != null &&
              Object.values(JSON.parse(data.service_type))[1] ? (
                  <>
                    <div className="post">
                      {data.service_type != null
                          ? renderServiceIcon(
                              Object.keys(JSON.parse(data.service_type))[1]
                          )
                          : ""}
                      <h5>
                        {data.service_type != null
                            ? t(Object.values(JSON.parse(data.service_type))[1])
                            : ""}
                      </h5>
                    </div>
                    <div className="vi-special"></div>
                    <div className="post_pay">
                      <img
                          src={window.location.origin + "/img/post_pay.png"}
                          alt=""
                      />
                      {language == 'sr' ? (
                          <h5>
                            {getPrice(Object.keys(JSON.parse(data.service_type))[1]) !== null
                                ? getPrice(Object.keys(JSON.parse(data.service_type))[1])
                                    .substr(getPrice(Object.keys(JSON.parse(data.service_type))[1]).lastIndexOf("\\") + 1)
                                    .split("-")[0] *
                                100 +
                                " - " +
                                getPrice(Object.keys(JSON.parse(data.service_type))[1])
                                    .substr(getPrice(Object.keys(JSON.parse(data.service_type))[1]).lastIndexOf("\\") + 1)
                                    .split("-")[1] *
                                100

                                : ""}
                            {t("time-hour")}
                          </h5>
                      ) : (
                          <h5>
                            $
                            {getPrice(Object.keys(JSON.parse(data.service_type))[1]) != null ?
                                getPrice(Object.keys(JSON.parse(data.service_type))[1])
                                : ""}
                            {t("time-hour")}
                          </h5>
                      )}
                    </div>
                    <div className="vi"></div>
                  </>
              ) : (
                  ""
              )}
              <div className="post_fet">
                <img
                    src={`${window.location.origin}/images/post_fet.svg`}
                    alt=""
                />
                <h5>
                  {getTranslatedInterest()}
                </h5>
              </div>
              <div className="vi"></div>
              <div className="post_cal">
                <img
                    src={`${window.location.origin}/images/post_cal.svg`}
                    alt=""
                />
                <h5>
                  {data.tutorstartdate != null
                      ? data.tutorstartdate
                      : data.nanystartdate}
                </h5>
              </div>
              <div className="vi"></div>
              <div className="post_loc">
                <img
                    src={`${window.location.origin}/images/post_loc.svg`}
                    alt=""
                />
                <h5>
                  {data.country != null ? data.country : ""} ,
                  {data.city != null ? data.city : ""}
                </h5>
              </div>
            </div>
            <p id={`half${index}`}>
              {data.about
                  ? expanded || data.about.length <= 100
                      ? data.about
                      : data.about.substring(0, 100)
                  : ""}
              {data.about != null && data.about.length > 100 ? (
                  <span
                      onClick={() => setExpanded(!expanded)
                      }
                  >
                {expanded ? t("text-less") : t("text-more")}
              </span>
              ) : (
                  ""
              )}
            </p>

          </div>
              </div>
          <div className="job_bottom">
          <div className="find_search">
            <Link to="/search-providers">
              <SearchIcon />
              {t("search-similar-candidate")}
            </Link>
          </div>
          <div className="view_profile_btn">
            <Link to="" onClick={(e) => setView(data.user_id)}>
              {t("send-message")}
            </Link>
            <Link to={`/profile-provider/${data.user_id}`}>
              {t("visit-profile")}
            </Link>
          </div>
          </div>
            {(data.childmedicalcondition != null &&
                data.childmedicalcondition == "Yes") ||
            (data.childanyallergies != null && data.childanyallergies == "Yes") ? (
                <>
                  <p>
                    <MarkRoundIcon />
                    <strong>{t("note-with")}</strong>
                    {t(
                        "record-indicates"
                    )}
                    <br />
                  </p>
                </>
            ) : (
                ""
            )}
          </div>
          <div className={"social_share_job"}>
          {data.plateformsocialmedia == "Yes" ? (
              <SocialFacebook
                  link={`${window.location.origin}/profile-provider/${data.user_id}`}
              />
          ) : (
              ""
          )}
          </div>
        </div>
      </div>
  );
};